<style>
.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #FFF;
  border-bottom-color: var(--bs-primary);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.loader-container{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<template>
  <div class="loader-container" v-if="show">
    <div class="loader"></div>
  </div>
</template>


<script>
export default {
  name: 'KLoader',
  components: {
  },
  data(){
    return{
      show:false
    }
  },
  mounted() {
    this.$store.subscribe(async (mutation, state) => {
      if(mutation.type==='showLoader'){
        this.show=true;
      }
      if(mutation.type==='hideLoader'){
        setTimeout(()=>{
          this.show=false;
        }, 500)
      }
    })
  },
};
</script>